var map = {
	"./act": 1479,
	"./act.tsx": 1479,
	"./gmat": 1480,
	"./gmat.tsx": 1480,
	"./gre": 1481,
	"./gre.tsx": 1481,
	"./ielts": 1482,
	"./ielts.tsx": 1482,
	"./ielts_general_training": 1483,
	"./ielts_general_training.tsx": 1483,
	"./lsat": 1484,
	"./lsat.tsx": 1484,
	"./mcat": 1485,
	"./mcat.tsx": 1485,
	"./sat": 1486,
	"./sat.tsx": 1486,
	"./toefl": 1487,
	"./toefl.tsx": 1487
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2501;
module.exports = webpackAsyncContext;